
  const ruleCertification = {
    path: "/ruleCertification",
    name: "ruleCertification",
    component: () => import(/* webpackChunkName: "rule_certification" */ "@/components/ruleCertification/RuleCertificationIndex.vue"),
    children: [
      { path: "view/:id", component: () => import(/* webpackChunkName: "rule_certification" */ "@/components/ruleCertification/RuleCertificationView.vue"), name: "ruleCertificationView" },
      { path: "edit/:id", component: () => import(/* webpackChunkName: "rule_certification" */ "@/components/ruleCertification/RuleCertificationEdit.vue"), name: "ruleCertificationEdit" },
      { path: "create/:requirementId", component: () => import(/* webpackChunkName: "rule_certification" */ "@/components/ruleCertification/RuleCertificationCreate.vue"), name: "ruleCertificationCreate"}
    ],
    meta: { authorize: [], requiresAuth: true }
  };

export default ruleCertification;
    